import { WithChildrenProps } from 'types';
import React from 'react';
import 'styles/sass/header.scss';
import { MenuOutlined } from '@ant-design/icons';
import { useIsMobile } from 'hooks/useResponsive';
import { Button, Layout } from 'antd';

interface MainHeaderProps extends WithChildrenProps {
  isTwoColumnsLayout: boolean;
  onToggleSider?: () => void;
}

export const MainHeader: React.FC<MainHeaderProps> = ({
  isTwoColumnsLayout,
  children,
  onToggleSider,
}) => {
  const mobileOnly = useIsMobile();

  return (
    <Layout.Header
      className={`main-header ${isTwoColumnsLayout ? 'two-columns' : ''}`}
    >
      <div>
        {mobileOnly && (
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={onToggleSider}
            className="menu-toggle-btn"
          />
        )}
      </div>
      <div className="header-right">{children}</div>
    </Layout.Header>
  );
};
